// IE 2026 09 13 / ODOO-335246 (Igor): СТАНДАРТНАЯ раскладка графа каскада — каркас Sugiyama через dagre (ранжирование network simplex,
// порядок в слое — барицентр, координаты в слое — Brandes–Köpf) поверх НАШЕЙ модели: уровни (колонки бэка), дорожки (рабочие области) — IE 2026 11 02 / ODOO-349799 (workspace-wording)
// и группы источников берутся из данных бэка; габарит узла = тело + иконка + ПОДПИСЬ в пикселях (шрифт известен только на фронте),
// ширина колонки уровня = самый широкий габарит уровня — подписи не накрывают узлы соседней колонки ПО ПОСТРОЕНИЮ.
// Опциональный движок (заказ Igor 13.09: «опциональное добавление с самовключением»): флаги в одном месте — window.ieGraphLayout
// (get / set / reset / apply), источник: URL ?graph_layout=… > localStorage 'ie.graph.layout' > doc.params.graph_engine_std > умолчания.
// Умолчание с 13.09 15:20 — 'be' (раскладка бэка; Igor: со std «стало хуже»); std включается опцией шестерёнки / set({engine:'std'}). Замер времени — в консоли (timings).
import dagre from 'dagre'

const KEY = 'ie.graph.layout'
const DEFAULTS = Object.freeze({
    engine: 'be',               // 'std' — Sugiyama/dagre на фронте; 'be' — координаты бэка. IE 2026 09 13 15:20 (Igor): «стало хуже» — умолчание 'be', std — по опции
    ranker: 'network-simplex',  // dagre: 'network-simplex' | 'tight-tree' | 'longest-path' (уровни закреплены якорями, влияет на фиктивные узлы)
    align: 'UL',                // Brandes–Köpf: 'UL' | 'UR' | 'DL' | 'DR' | '' (усреднение четырёх выравниваний)
    nodesep: 22,                // px между соседями по вертикали в слое
    compound: true,             // группы источников — вложенные кластеры dagre (узлы группы держатся вместе)
    visibleOnly: true,          // скрытые на графе рёбра (graph_hide) в раскладке не участвуют
    labelRight: true,           // подпись всегда справа от узла (габарит считан для этого положения)
    colGap: 36,                 // px между колонками уровней (после самой длинной подписи)
    laneGap: 48,                // px между дорожками
    pad: 10,                    // px от границы колонки до тела узла
    timings: true,              // замер в консоли
})
const registry = new Set()

function readStore() {
    try { const v = localStorage.getItem(KEY); return v ? JSON.parse(v) : {} } catch (e) { return {} }
}
function readUrl() {
    try {
        const m = /[?&#]graph_layout=([^&#]+)/.exec(location.href)
        if (!m) return {}
        const v = decodeURIComponent(m[1])
        if (v === 'be' || v === 'std') return { engine: v }
        return JSON.parse(v)
    } catch (e) { return {} }
}
export const ieGraphLayout = {
    /** действующие флаги: URL > localStorage > doc.params (graph_engine_std) > умолчания */
    get(params) {
        const p = params || {}
        const fromParams = p.graph_engine_std === true ? { engine: 'std' } : (p.graph_engine_std === false ? { engine: 'be' } : {})   // IE 2026 09 13 (Igor): std — только явно
        return { ...DEFAULTS, ...fromParams, ...readStore(), ...readUrl() }
    },
    set(patch) { const v = { ...readStore(), ...(patch || {}) }; try { localStorage.setItem(KEY, JSON.stringify(v)) } catch (e) { /* приватный режим */ } return this.apply() },
    reset() { try { localStorage.removeItem(KEY) } catch (e) { /* */ } return this.apply() },
    defaults() { return { ...DEFAULTS } },
    /** переложить все живые графы с текущими флагами (без перезагрузки) */
    apply() { let n = 0; for (const vm of registry) { try { if (vm._rawDataGraph) { vm.load_data(vm._rawDataGraph); n++ } } catch (e) { console.warn('ieGraphLayout.apply', e) } } return n },
    register(vm) { registry.add(vm) },
    unregister(vm) { registry.delete(vm) },
}
if (typeof window !== 'undefined') window.ieGraphLayout = ieGraphLayout

let measureCtx = null
function measureText(text, font) {
    if (!measureCtx) measureCtx = document.createElement('canvas').getContext('2d')
    measureCtx.font = font
    return measureCtx.measureText(String(text || '')).width
}

/**
 * Стандартная раскладка. dg — данные бэка {nodes, edges, graphContext}; возвращает НОВЫЙ объект с координатами (единицы = px при
 * масштабе 1, y вверх — как у sigma/бэка) и перестроенными областями; при неподходящих данных (нет уровней/дорожек) — dg как есть.
 */
export function layoutStd(dg, opts, settings) {
    const t0 = performance.now()
    const o = { ...DEFAULTS, ...(opts || {}) }
    const fs = settings?.labelSize || 14, font = `${settings?.labelWeight || ''} ${fs}px ${settings?.labelFont || 'Arial'}`.trim()
    const rows = dg?.graphContext || [], nodes = dg?.nodes || [], edges = dg?.edges || []
    const lanesB = rows.filter(r => r.type === 'rect' && !r.anchor && r.title && r.y0 != null && r.y1 != null).sort((a, b) => b.y0 - a.y0)
    const strokes = rows.filter(r => r.type === 'stroke' && r.x0 != null).map(r => r.x0).sort((a, b) => a - b)
    if (!nodes.length || !lanesB.length) return dg
    const level = (a) => strokes.filter(x => x <= a.x).length
    const nLv = strokes.length + 1
    const laneOf = (a) => { let i = lanesB.findIndex(l => a.y <= l.y0 && a.y >= l.y1); if (i < 0) { let best = Infinity; lanesB.forEach((l, j) => { const d = Math.min(Math.abs(a.y - l.y0), Math.abs(a.y - l.y1)); if (d < best) { best = d; i = j } }) } return i }
    const box = (a) => {
        const size = Number(a.size) || 6, own = a.own ? 9 : 0
        const iconW = a.icon ? 18 : 0
        const w = 2 * (size + own) + 4 + iconW + measureText(a.label, font) + 18   // +18: запас на иконку 20 px и отступ подписи (замер 13.09: подпись упиралась в узел следующей колонки)
        const h = Math.max(2 * (size + own), fs + 4) + o.nodesep * 0
        return { w, h, size, own }
    }
    const info = new Map()
    for (const n of nodes) { const a = n.attributes || {}; info.set(n.key, { a, lv: level(a), lane: laneOf(a), ...box(a) }) }
    // ширина колонки уровня — самый широкий габарит по всем дорожкам
    const W = new Array(nLv).fill(60)
    for (const v of info.values()) if (v.w > W[v.lv]) W[v.lv] = v.w
    const X = [0]
    for (let k = 1; k < nLv; k++) X[k] = X[k - 1] + W[k - 1] + o.colGap
    // группы (прямоугольники с anchor.nodes) — вложенные кластеры
    const groups = rows.filter(r => (r.type === 'rect' || r.type === 'fillRect') && r.anchor?.nodes?.length).map((r, i) => ({ r, id: '__g' + i, keys: r.anchor.nodes.filter(k => info.has(k)), depth: r.anchor.depth || 0 }))
    const parentGroup = (g) => { let best = null; for (const h of groups) { if (h === g || h.depth >= g.depth) continue; if (g.keys.every(k => h.keys.includes(k)) && (!best || h.depth > best.depth)) best = h } return best }
    const deepest = (key) => { let best = null; for (const g of groups) if (g.keys.includes(key) && (!best || g.depth > best.depth)) best = g; return best }
    const laneH = [], out = new Map()
    lanesB.forEach((lane, li) => {
        const mine = [...info.entries()].filter(([, v]) => v.lane === li)
        if (!mine.length) { laneH.push(40); return }
        const run = (compound) => {
            const g = new dagre.graphlib.Graph({ compound, multigraph: false })
            g.setGraph({ rankdir: 'LR', nodesep: o.nodesep, ranksep: 8, edgesep: 6, marginx: 0, marginy: 0, ranker: o.ranker, ...(o.align ? { align: o.align } : {}) })
            g.setDefaultEdgeLabel(() => ({}))
            const lvs = [...new Set(mine.map(([, v]) => v.lv))].sort((a, b) => a - b)
            const anchors = new Map()   // уровень → якорь ранга: уровни закреплены (ранг узла = 2k+1, якоря — чётные ранги)
            for (let k = 0; k < nLv; k++) { const id = '__a' + k; anchors.set(k, id); g.setNode(id, { width: 1, height: 1 }); if (k) g.setEdge('__a' + (k - 1), id, { minlen: 2, weight: 0 }) }
            for (const [key, v] of mine) {
                g.setNode(key, { width: v.w, height: v.h })
                g.setEdge(anchors.get(v.lv), key, { minlen: 1, weight: 0 })
                if (anchors.has(v.lv + 1)) g.setEdge(key, anchors.get(v.lv + 1), { minlen: 1, weight: 0 })
            }
            for (const e of edges) {
                if (o.visibleOnly && (e.attributes || {}).graph_hide) continue
                const s = info.get(e.source), t = info.get(e.target)
                if (!s || !t || s.lane !== li || t.lane !== li || t.lv <= s.lv) continue
                g.setEdge(e.source, e.target, { minlen: 1, weight: Math.max(1, Number((e.attributes || {}).size) || 1) })
            }
            if (compound) {
                const gl = groups.filter(gr => gr.keys.length && gr.keys.every(k => info.get(k).lane === li))
                for (const gr of gl) g.setNode(gr.id, { label: gr.r.title || '' })
                for (const gr of gl) { const p = parentGroup(gr); if (p && gl.includes(p)) g.setParent(gr.id, p.id) }
                for (const [key] of mine) { const d = deepest(key); if (d && gl.includes(d)) g.setParent(key, d.id) }
            }
            dagre.layout(g)
            return g
        }
        let g = null
        try { g = run(o.compound) } catch (e) { console.warn('ieGraphLayout: compound layout failed, retry plain', e); g = run(false) }
        let hMax = 0
        for (const [key, v] of mine) { const p = g.node(key); if (!p) continue; out.set(key, { yPx: p.y, li }); if (p.y + v.h / 2 > hMax) hMax = p.y + v.h / 2 }
        laneH.push(Math.max(hMax + 6, 40))
    })
    const off = [0]
    for (let i = 1; i < lanesB.length; i++) off[i] = off[i - 1] + laneH[i - 1] + o.laneGap
    const nodesOut = nodes.map(n => {
        const v = info.get(n.key), p = out.get(n.key)
        if (!v || !p) return n
        return { ...n, attributes: { ...n.attributes, x: X[v.lv] + o.pad + v.size + v.own, y: -(off[p.li] + p.yPx) } }
    })
    const posOf = new Map(nodesOut.map(n => [n.key, n.attributes]))
    const xLeft = X[0] - 30, xRight = X[nLv - 1] + W[nLv - 1] + 30
    const top = -(off[0] - 22), bottom = -(off[lanesB.length - 1] + laneH[lanesB.length - 1] + 14)
    const ctxOut = []
    let ti = 0
    const titles = rows.filter(r => r.type === 'fillText').sort((a, b) => (a.x0 - b.x0) || ((a.y0_ptx || 0) - (b.y0_ptx || 0)))
    for (const r of rows) {
        if (r.type === 'rect' && !r.anchor && r.title && r.y0 != null) {
            const li = lanesB.indexOf(r)
            ctxOut.push({ ...r, x0: xLeft, x1: xRight, y0: -(off[li] - 22), y1: -(off[li] + laneH[li] + 14) })
        } else if ((r.type === 'rect' || r.type === 'fillRect') && r.anchor?.nodes?.length) {
            const ks = r.anchor.nodes.filter(k => posOf.has(k)); if (!ks.length) { ctxOut.push({ ...r }); continue }
            const d = r.anchor.depth || 0
            let y0 = -Infinity, y1 = Infinity, lv = null
            for (const k of ks) { const a = posOf.get(k), v = info.get(k); if (a.y + v.h / 2 > y0) y0 = a.y + v.h / 2; if (a.y - v.h / 2 < y1) y1 = a.y - v.h / 2; lv = v.lv }
            ctxOut.push({ ...r, x0: X[lv] - o.colGap * 0.4 + d * 8, x1: X[lv] + W[lv] + o.colGap * 0.4 - d * 8, y0: y0 + 18 + (2 - d) * 4, y1: y1 - 6 })
        } else if (r.type === 'stroke') {
            const k = strokes.indexOf(r.x0) + 1
            const x = X[k] - o.colGap / 2
            ctxOut.push({ ...r, x0: x, x1: x, y0: top, y1: bottom })
        } else if (r.type === 'fillText') {
            const k = Math.floor(titles.indexOf(r) / 2)
            ctxOut.push({ ...r, x0: X[k] + W[k] / 2 - 30, y0: bottom })
            ti++
        } else ctxOut.push({ ...r })
    }
    const res = { ...dg, nodes: nodesOut, graphContext: ctxOut, _layoutStd: true }
    if (o.timings) console.log(`ieGraphLayout: std layout ${nodes.length} nodes, ${lanesB.length} lane(s), ${nLv} levels in ${(performance.now() - t0).toFixed(1)} ms`)
    return res
}
